module.exports = __webpack_public_path__ + "img/show-attendee-search.5ae8812e.jpg";